import { trackEvent } from './tracking.service';

export const ONBOARDING_FLOW = 'onboarding';
export const PER_FORM_VALIDATION_MODE = 'Per Form';

interface ReportStepContinueClickedParams {
  step: string;
  isValid: boolean;
  invalidFields: string[];
  attemptNumber: number;
}

export const reportOnboardingStepContinueClicked = ({
  step,
  isValid,
  invalidFields,
  attemptNumber,
}: ReportStepContinueClickedParams) => {
  trackEvent('Onboarding Step Continue Clicked', {
    Step: step,
    flow: ONBOARDING_FLOW,
    isValid,
    invalid_fields: invalidFields.join(','),
    attempt_number: attemptNumber,
  });
};

interface ReportOnboardingValidationErrorParams {
  step: string;
  fieldErrors: string[];
}

export const reportOnboardingValidationError = ({
  step,
  fieldErrors,
}: ReportOnboardingValidationErrorParams) => {
  trackEvent('Onboarding Validation Error', {
    Step: step,
    flow: ONBOARDING_FLOW,
    error_count: fieldErrors.length,
    field_errors: fieldErrors,
    validation_mode: PER_FORM_VALIDATION_MODE,
  });
};
